export default __webpack_public_path__ + "static/media/Laura_e_Fabio.f11110aa.jpg";